import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppSupport.css";

const WhatsAppSupport = () => {
  const handleWhatsAppClick = () => {
    const whatsappUrl = "https://wa.link/ik0ub1";
    window.open(whatsappUrl, "_blank");
  };

  return (
    <button className="whatsapp-support-button" onClick={handleWhatsAppClick}>
      <FaWhatsapp className="whatsapp-icon" />
      <span className="whatsapp-text">Suporte</span>
    </button>
  );
};

export default WhatsAppSupport;